import React from 'react';

import { useTranslation } from 'react-i18next';

export const FeaturesList: React.FC = () => {
  const { t } = useTranslation('pleri/onboarding');

  return (
    <div className="mb-4 text-center">
      <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
        <a
          href="https://docs.pleri.ai/tools/chrome"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline hover:text-blue-700"
        >
          {t('clickHereToLearnMore')}
        </a>
      </p>
    </div>
  );
};
